
import UpTimeArrowUpIcon from '../../assets/icons/SuperAdminDashboard/SystemPerformance/UpTimeArrowUpIcon.svg'
import UpTimeArrowDownIcon from '../../assets/icons/SuperAdminDashboard/SystemPerformance/UpTimeArrowDownIcon.svg'
  

  

 export  const systemPerformanceData  = [
    {
      key: '1',
      ArrowUpIcon:UpTimeArrowUpIcon,
      from: '01/11/2021    10:50:40 Am',
      to: '01/11/2021    10:50:40 Am',
      responseTime: '20 days',
      arrowUpIconAlt:"ArrowUpIcon",
    
    },
    {
      key: '2',
      ArrowDownIcon:UpTimeArrowDownIcon,
      from: '01/11/2021    10:50:40 Am',
      to: '01/11/2021    10:50:40 Am',
      responseTime: '01 month',
      arrowDownIconAlt:"ArrowDownIcon",
    
    },
  ];

  export const usedData =[
    { 
      id:1,
      title:"Used",
      used:"80.28 MB",
      
    },
    { 
      id:2,
      title:"Free",
      used:"414.17 MB",
     
    },
    { 
      id:3,
      title:"Total",
      used:"494.45 MB",
    
    }
  ]